@font-face {
  font-family: 'Futura';
  src: url('./futura.ttf') format('ttf');
}

.container {
  display: flex;
  width: 100vw;
  flex-direction: column;
}

.primary {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 76px;
  background: #d89806;
}

.futura {
  font-family: 'Futura';
}

.logoContainer {
  max-width: 766px;
  width: 90%;
  display: flex;
  align-items: flex-end;
  font-size: 28px;
  color: white;
  gap: 10px;
}

.logoButton {
  display: block;
  width: 50px;
  height: 52px;
  border: none;
  background: url('https://app.peranto.xyz/_next/static/media/peranto_logo.4c79765f.svg')
    no-repeat;
  cursor: pointer;
}

.secondary {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 30px;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  background: #d89806;
}

.text {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  max-width: 766px;
  width: 90%;
  color: var(--color-light-blue);
  font-size: 14px;
  margin-bottom: 5px;
  letter-spacing: 0.1px;
  line-height: 16px;
}

@media (width <= 600px) {
  .text {
    visibility: hidden;
  }
}
